import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbOptionComponent, NbSelectComponent, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ConfigDataClass } from '../../../em-common/config/config';
import {  TranslateService } from '@ngx-translate/core';
import { isEqual } from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
  
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';
  public lang:string[]=ConfigDataClass.configData.languages ;
  public currentlang=localStorage.getItem('lang')!==null?localStorage.getItem('lang'):'en';
  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  
  @ViewChild('dynamicSelect', { static: true }) dynamicSelect: NbSelectComponent | null = null;
  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private breakpointService: NbMediaBreakpointsService,public translate: TranslateService) {
                 
                this.lang= ConfigDataClass.configData.languages 
                this.currentlang=  localStorage.getItem('lang')!==null?localStorage.getItem('lang'):'en';
                this.currentTheme =  localStorage.getItem('currentTheme')!==null?localStorage.getItem('currentTheme'):this.themeService.currentTheme;


                let dateFormat: string = "";
                this.translate.get("date").subscribe((data: any) => {
                  dateFormat = data;
                  localStorage.setItem('dateFormat',dateFormat);
                });
                    
  }
  ngAfterViewInit(): void {
    this.currentlang=  localStorage.getItem('lang')!==null?localStorage.getItem('lang'):'en';
                
  }
  private refreshSelect(): void {
    HeaderComponent.setOptionNbSelect(this.dynamicSelect, this.lang);
  }
  static setOptionNbSelect(selectComponent: NbSelectComponent | null, optToCompare: any) {
    setTimeout(() => {
      if (selectComponent) {
        const selectedOptions: NbOptionComponent[] = [];
        for (const option of selectComponent.options['_results']) {
          if (isEqual(optToCompare, option['value'])) {
            selectedOptions.push(option);
            break;
          }
        }
        for (const option of selectedOptions) {
          selectComponent['selectOption'](option);
        }
        selectComponent['cd'].detectChanges();
      }
    }, 500);
  }
  ngOnInit() {
    this.currentTheme =  localStorage.getItem('currentTheme')!==null?localStorage.getItem('currentTheme'):this.themeService.currentTheme;
 
    this.themeService.changeTheme(this.currentTheme);
    this.currentlang=  localStorage.getItem('lang')!==null?localStorage.getItem('lang'):'en';
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      this.refreshSelect();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
    localStorage.setItem('currentTheme',themeName);
  }
  changeLang(lang: string) {
    this.currentlang=lang;
    this.translate.currentLang=this.currentlang; 
    let dateFormat: string = "";
                this.translate.get("date").subscribe((data: any) => {
                  dateFormat = data;
                  localStorage.setItem('dateFormat',dateFormat);
                });
   localStorage.setItem('lang',lang);
  
   location.reload();
  }
  
  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

 
}
